// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"styles_buttonLink__e7ifA","activedStyle":"styles_activedStyle__1S1p_"};